module.exports = __webpack_public_path__ + "media/images/image-form-7c8287028999693c91d9b37610292f86.jpg";